module.exports = __webpack_public_path__ + "img/7.fa3094c6.jpg";